import React from 'react';
import './railposition.css';
import rail from '../../images/rail-icon.svg';
import Weather from '../../models/weather';

const RailPosition: React.FC<{weather: Weather}> = ({weather}) => {
    const thisMeeting = weather.goingStick?.thisMeeting?.railPosition?.slice(0, 40) ?? "―";
    const lastMeeting = weather.goingStick?.lastMeeting?.railPosition?.slice(0, 40) ?? "―";
    let pluginURL = (window as { [key: string]: any })['smartWeatherAppUrl']['baseUrl'] as string;

    const railImageSrc = pluginURL + rail;
    return (
        <div className="rail-position-container">
            <div className='rail-position-title'>
                Rail Position
            </div>
            <div className='rail-position-content'>
                <div className='rail-position-image'>
                    <img src={railImageSrc} alt='rail' className='rail-image' />
                </div>
                <div className='small-text'>
                    Current
                </div>
                <div className='big-text rail-position-value'>
                    { thisMeeting }
                </div>
                <div className='small-text'>
                    Last Meeting 
                </div>
                <div className='big-text  rail-position-value'>
                    { lastMeeting }
                 </div>
            </div>
        </div>
    );
} 

export default RailPosition;